/**
 * SystemApplicationSetting page
 */

// React
import React, { FC } from 'react';

// Libraries
import { generatePath, useNavigate } from 'react-router-dom';

// Material
import { Table, TableBody, TableCell, TableRow, Box, IconButton } from '@mui/material';

// Components
import TableHeader from 'components/TableHeader';
import SelectInput from 'components/SelectInput';
import SearchInput from 'components/SearchInput';
import InformationModal from './informationModal';
import TotalRecords from 'components/TotalRecords';
import PaginationComponent from 'components/Pagination';
import WrapperInformationModal from 'components/WrapperInformationModal';

// Data mock
import {
  defaultParamsApplicationSetting,
  headerSystemApplicationSetting,
  menuItems,
} from 'initDataPages';

// Images
import { edit_icon, information_icon } from 'assets/icons';

// Common styles
import {
  BpIcon,
  BoxNoDataList,
  BpCheckedIcon,
  PageContainer,
  CustomTableHead,
  RecordsContainer,
  CustomTableContainer,
  WrapperSearchAndButton,
} from 'styles';

// Utils
import { DataSystemApplicationSetting } from 'utils/types';
import { NOTIFICATION_MESSAGES, VALUE_MENU } from 'utils/constants';

// Hooks
import useGetListData from 'hooks/useGetListData';

// Services
import SystemService from 'services/SystemService';

// Router
import ROUTES from 'configs/route';

// Component
const SystemApplicationSetting: FC = () => {
  const navigate = useNavigate();

  const {
    state,
    perPage,
    dataList,
    isLoading,
    totalPages,
    currentPage,
    totalRecords,
    paramsGetList,
    stateInformation,
    scrollContainerRef,

    setNotify,
    isSortable,
    handleCloseInfo,
    handleChangePage,
    handleRequestSort,
    setStateInformation,
    handleOpenInformation,
  } = useGetListData<DataSystemApplicationSetting>(
    (paramsGetList) => SystemService.getSystemApplicationSetting(paramsGetList),
    undefined,
    undefined,
    defaultParamsApplicationSetting
  );

  const generalDataInformation = [{ label: 'システム名', value: stateInformation?.title }];

  const handleEdit = (id: number) => {
    const path = generatePath(ROUTES.SETTING_CONTENT_SYSTEM, { service_id: id });
    setNotify({ open: false });
    navigate(path);
  };

  return (
    <PageContainer>
      <WrapperInformationModal
        paddingLeft="0px"
        open={state.openInformation ?? false}
        title="システムアイコン詳細情報"
        handleCloseInformation={handleCloseInfo}
        generalDataInformation={generalDataInformation}
      >
        <InformationModal data={stateInformation} />
      </WrapperInformationModal>

      <SelectInput menuItems={menuItems} defaultValue={VALUE_MENU.SYSTEM_SETTING} />

      <RecordsContainer>
        <TotalRecords
          recordsPerPage={perPage}
          currentPage={currentPage}
          totalRecords={totalRecords}
        />
        <WrapperSearchAndButton>
          <SearchInput />
        </WrapperSearchAndButton>
      </RecordsContainer>

      <CustomTableContainer>
        <Box className="table-container" ref={scrollContainerRef}>
          <Table aria-label="register user table">
            <CustomTableHead>
              <TableHeader
                isSortable={isSortable}
                paramsGetList={paramsGetList}
                handleRequestSort={handleRequestSort}
                header={headerSystemApplicationSetting}
              />
            </CustomTableHead>
            <TableBody>
              {dataList && dataList?.length > 0
                ? dataList?.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row?.position}</TableCell>
                      <TableCell align="center">
                        {row?.is_displayed === 1 ? <BpCheckedIcon /> : <BpIcon />}
                      </TableCell>

                      <TableCell align="left">{row?.title || ''}</TableCell>
                      <TableCell align="left">{row?.body || ''}</TableCell>
                      <TableCell align="left">{row?.callback_url || ''}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          sx={{ mr: 2 }}
                          onClick={() => {
                            setStateInformation(row);
                            handleOpenInformation();
                          }}
                        >
                          <img
                            src={information_icon}
                            alt="information_icon"
                            style={{ width: '25px', height: 'auto', cursor: 'pointer' }}
                          />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">{row?.color || ''}</TableCell>
                      <TableCell align="left">{row?.created_at || ''}</TableCell>
                      <TableCell align="left">{row?.updated_at || ''}</TableCell>

                      <TableCell align="center">
                        <IconButton onClick={() => handleEdit(row?.id)}>
                          <img
                            src={edit_icon}
                            alt="remove"
                            style={{ width: '25px', height: 'auto', cursor: 'pointer' }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                : null}
            </TableBody>
          </Table>
          {dataList?.length === 0 && !isLoading && (
            <BoxNoDataList>{NOTIFICATION_MESSAGES.ERROR.SEARCH}</BoxNoDataList>
          )}
        </Box>
      </CustomTableContainer>

      <PaginationComponent
        totalPages={totalPages}
        currentPage={currentPage}
        dataLength={totalRecords}
        handleChangePage={handleChangePage}
      />
    </PageContainer>
  );
};

export default SystemApplicationSetting;
